<template>
    <div class="CoursePanel">
        <Carousel
            :items="systems"
            items-type="systems"
            :title="$t('systems')"
            :active-system-id="activeSystemId"
            @systemClicked="onClick"
        />

        <transition name="expand-collapse" mode="out-in">
            <SystemsDashboard
                v-if="activeSystemId"
                :key="activeSystemId"
                class="systems-dashboard"
                :system-id="activeSystemId"
                @close="hideSystemsDashboard"
            />
        </transition>

        <Carousel :items="gamesIds" items-type="games" :title="$t('games')" />
    </div>
</template>

<translations>
  systems: 'Systems'
  systems_no: 'Systemer'
  games: 'Games'
  games_no: 'Spill'
</translations>

<script>
import { mapActions, mapGetters } from 'vuex';

import Carousel from '@/components/Carousel/';
import SystemsDashboard from './SystemsDashboard';

export default {
    components: {
        Carousel,
        SystemsDashboard
    },

    data() {
        return {
            activeSystemId: null
        };
    },

    computed: {
        ...mapGetters({
            systems: 'moduleCourse/getSystems',
            gamesIds: 'moduleMemogenius/getGameIds'
        })
    },

    methods: {
        onClick(e) {
            const systemId = e.systemId;

            this.handleSystemsDashboardVisibility(systemId);
        },

        handleSystemsDashboardVisibility(systemId) {
            const isActiveSystemClicked = this.activeSystemId === systemId;

            if (isActiveSystemClicked) {
                this.hideSystemsDashboard();
            } else {
                this.showSystemsDashboard(systemId);
            }
        },

        hideSystemsDashboard() {
            this.activeSystemId = null;
        },

        showSystemsDashboard(systemId) {
            this.activeSystemId = systemId;
        }
    }
};
</script>

<style lang="scss" scoped>
$statsSectionBackroundColor: mix(black, white, 5%);

.CoursePanel {
    background-color: $statsSectionBackroundColor;
    overflow: hidden;
    padding-left: calc(calc(100vw - 965px) / 2);
    .Carousel {
        margin: 3em 0;
    }
}

.systems-dashboard {
    overflow: hidden;
    max-height: 100%;
}

.expand-collapse-enter-active,
.expand-collapse-leave-active {
    transition: 0.7s;
}
.expand-collapse-enter,
.expand-collapse-leave-to {
    max-height: 0;
}
</style>
